import { render, staticRenderFns } from "./AdicionarPecaForm.vue?vue&type=template&id=b7b934ec&scoped=true&"
import script from "./AdicionarPecaForm.vue?vue&type=script&lang=js&"
export * from "./AdicionarPecaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b934ec",
  null
  
)

export default component.exports